import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { SvgIconProps as DefaultSvgIconProps } from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core/styles';

export const VerifierIcon = (props: DefaultSvgIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon {...props} viewBox="0 0 47.98 48.039">
      <path
        id="Path_99"
        data-name="Path 99"
        d="M29.693,0A18.279,18.279,0,0,0,14.132,27.884L0,42.071l5.968,5.968L20.1,33.851A18.285,18.285,0,1,0,29.693,0ZM5.964,44.056,3.975,42.067,6.2,39.832l1.989,1.989Zm4.212-4.228L8.187,37.838l7.627-7.656A18.44,18.44,0,0,0,17.8,32.171Zm19.517-6.066A15.474,15.474,0,1,1,45.167,18.288,15.492,15.492,0,0,1,29.693,33.762Z"
        fill={props.color ? props.color : theme.palette.secondary.main}
      />
      <path
        id="Path_101"
        data-name="Path 101"
        d="M251.11,160.363l-3.226-3.226-1.989,1.989,5.215,5.215,8.028-8.028-1.989-1.989Z"
        transform="translate(-222.824 -139.844)"
        fill={props.color ? props.color : theme.palette.secondary.main}
      />
    </SvgIcon>
  );
};
